import { createUseStyles, ComposedTheme } from '@glu/theming';

const styles = ({ dataComponents: { drawer } }: ComposedTheme) => {
  const { columns } = drawer;
  return {
    unpinAllButton: {
      color: columns.unpinAllButtonTextColor,
      margin: [8, 0],
    },
    columnActions: {
      fontFamily: columns.text.font.fontFamily,
      color: columns.text.color,
      '& > span': {
        fontFamily: columns.header.font.fontFamily,
        fontSize: columns.header.font.fontSize,
        fontWeight: columns.header.font.fontWeight,
        textTransform: columns.header.font.textTransform,
        display: 'block',
        margin: '5px 0',
      },
      padding: '0 15px 5px',
    },
    contentScroll: {
      '&::-webkit-scrollbar': {
        width: 10,
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: drawer.scrollbarColor,
      },
      '&::-webkit-scrollbar-track': {
        backgroundColor: drawer.scrollbarBackground,
      },
      flex: 1,
      overflowY: 'auto',
      fontFamily: columns.text.font.fontFamily,
      padding: [0, 8],
    },
    wrapper: {
      fontFamily: columns.text.font.fontFamily,
      overflowY: 'auto',
    },
    itemWrapper: {
      '&:hover, &:focus, &:focus-within': {
        backgroundColor: columns.itemHoverColor,
      },
      '& > label': {
        margin: 0,
      },
      padding: 8,
      marginBottom: 5,
      borderRadius: 2,
    },
  };
};

export default createUseStyles(styles);
